import { Component, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
import { SessionService } from '../services/session.service';
import { SystemService } from '../services/system.service';
import { Version } from '../classes/version';

import { ConfigService } from '../../config/config.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {

    buildVersion: Version;
    reportingSubMenu: boolean = true;
    isAdmin: boolean;
    download: string;

    constructor(private systemService: SystemService,
        private userService: UserService,
        private sService: SessionService,
        private router: Router,
        private config: ConfigService) {
            if ('/reporting-members' === router.url || '/reporting-merchants' === router.url ||
                '/reporting-comparison' === router.url || '/reporting-internal-orders' === router.url) {
                this.reportingToggle();
            }
            this.download = config.terminalDownloadURL;
        }

    ngOnInit() {
        this.systemService.getVersion().subscribe(data => {
            this.buildVersion = new Version(data.major, data.minor, data.buildNumber, data.gitHash, data.gitBranch);
        });
        this.sService.getUserType() === 'PORTAL' ? this.isAdmin = false : this.isAdmin = true;
    }

    reportingToggle() {
        this.reportingSubMenu = !this.reportingSubMenu;
    }

    logOut() {
        this.userService.userLogout()
            .subscribe(
            data => {
                this.sService.destroySessionCookie(true);
                this.router.navigate(['/']);
            },
            error => {
                this.sService.destroySessionCookie(true);
                this.router.navigate(['/']);
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/sidebar/sidebar.component.ts